import s from './GalleryHero.module.scss';
import { useLanguage } from '../../contexts/LanguageContext';

const YOUTUBE_URL = 'https://www.youtube.com/watch?v=Lrb9aTqIfsA';

const getYoutubeEmbedUrl = (url) => {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
  const videoId = match?.[1];

  if (!videoId) return '';

  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&playsinline=1&modestbranding=1&rel=0&vq=hd1080&hd=1`;
};

const TEXT = {
  JP: {
    kicker: 'Capturing unforgettable moments in Miyakoisland',
    title: 'その瞬間を、最高の形で',
  },
  EN: {
    kicker: 'Capturing unforgettable moments in Miyakoisland',
    title: 'Capturing your best moments',
  },
  中文: {
    kicker: '在宫古岛记录难忘瞬间',
    title: '以最美的方式，留下那个瞬间',
  },
  한국어: {
    kicker: '미야코지마에서 잊지 못할 순간을 담다',
    title: '그 순간을 가장 아름답게',
  },
};

const GalleryHero = () => {
  const { lang } = useLanguage();
  const t = TEXT[lang] || TEXT.JP;
  const youtubeEmbedUrl = getYoutubeEmbedUrl(YOUTUBE_URL);

  return (
    <section className={s.root}>
      <iframe
        className={s.background}
        src={youtubeEmbedUrl}
        title="Miyako Island gallery movie"
        loading="eager"
        allow="autoplay; encrypted-media; picture-in-picture"
        allowFullScreen
      />

      <div className={s.overlay}>
        <span className={s.kicker}>{t.kicker}</span>
        <h1>{t.title}</h1>
      </div>
    </section>
  );
};

export default GalleryHero;
